<template>
  <header class="gfr-layout-header">
    <slot />
  </header>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.gfr-layout-header {
  @apply fixed left-0 top-0 z-40 h-30 w-full lg:h-18;
}
</style>
